import { createContext, useContext } from 'react';
var ModalContext =
/*#__PURE__*/
createContext({
  onClose: function onClose() {
    return void 0;
  },
  showCloseButton: true,
  variant: "base",
  size: "md",
  isDismissible: true,
  scrollBehavior: "inside"
});

var useModalContext = function useModalContext() {
  var context = useContext(ModalContext);
  return context;
};

export { ModalContext, useModalContext };